import restApi from "../../http.js";
import session from "../session";
import env from "../../env.js";

export default class AuthApi {
  signIn(request) {
    return restApi({
      method: "POST",
      url: "/auth/sign-in",
      data: {
        email: request.email,
        password: request.password,
      },
    });
  }

  inviteBrand(id) {
    return restApi({
      method: "POST",
      url: "/auth/brand/" + id + "/invite",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  inviteRetailer(id) {
    return restApi({
      method: "POST",
      url: "/auth/retailer/" + id + "/invite",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  resetPassword(request) {
    return restApi({
      method: "POST",
      url: "/auth/reset-password",
      data: request,
    });
  }

  forgotPassword(request) {
    return restApi({
      method: "POST",
      url: "/auth/forgot-password",
      data: request,
    });
  }

  getLoggedBrandInfo() {
    return restApi({
      method: "GET",
      url: "/brands/my-id",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  getLoggedRetailerInfo() {
    return restApi({
      method: "GET",
      url: "/retailers/my-id",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  signUpAsBrand(request) {
    return restApi({
      method: "POST",
      url: "/brands/apply-to-sell",
      data: request,
    });
  }

  signUpAsRetailer(request) {
    return restApi({
      method: "POST",
      url: "/retailers/apply-to-buy",
      data: request,
    });
  }

  verifyRetailer(request) {
    return restApi({
      method: "POST",
      url: "/auth/retailer/verify",
      data: request,
    });
  }

  verifyNewEmail(request) {
    return restApi({
      method: "POST",
      url: "/auth/change-email",
      data: request,
    });
  }

  sendFirstLoginAirtable(request) {
    return restApi({
      method: "post",
      url: "https://api.airtable.com/v0/apppSqO75O9KJd9dO/Table%201",
      data: {
        fields: {
          Email: request.email,
          Date: request.date,
        },
      },
      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }

  getZendDeskJWTToken(request) {
    return restApi({
      method: "POST",
      url: "/auth/zendesk-sign-in",
      data: {
        email: request.email,
        password: request.password,
      },
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}
